export const getLocalStorage = (key) => {
  try {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getLocalStorageJSON = (key) => {
  const value = getLocalStorage(key);
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const setLocalStorage = (key, value) => {
  try {
    if (typeof window === "undefined") return;
    localStorage.setItem(key, value);
  } catch {
    // fail silently
  }
};

export const removeLocalStorage = (key) => {
  try {
    if (typeof window === "undefined") return;
    localStorage.removeItem(key);
  } catch {
    // fail silently
  }
};
